var _circle, _circle2, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarSeminar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#07CF84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "url(#paint0_linear_8019:34052)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 13.3984H14.0004C13.669 13.3984 13.4004 13.6671 13.4004 13.9984V25.9984C13.4004 26.3298 13.669 26.5984 14.0004 26.5984H26.0004C26.3318 26.5984 26.6004 26.3298 26.6004 25.9984V13.9984C26.6004 13.6671 26.3318 13.3984 26.0004 13.3984Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5996 12.1992V14.5992",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4004 12.1992V14.5992",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4004 17H26.6004",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8019:34052",
    x1: 39.0567,
    y1: 25.3333,
    x2: -14.6152,
    y2: 24.6065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FCB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06FFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSeminar);
export default __webpack_public_path__ + "static/media/calendar_seminar.10f75ac7.svg";
export { ForwardRef as ReactComponent };